export default __webpack_public_path__ + "static/interviews-page-banner-a1e90def701f97fd0fd280605ad55912.png";